const ActiveLinksLabels = Object.freeze(['Website', 'Instagram', 'Facebook', 'Linkedin', 'Youtube', 'Twitter', 'Soundcloud']);

export default ActiveLinksLabels;
